export default __webpack_public_path__ + "static/summer_containers22-dcfe2aed8bb3a03c6bdc143700c0135c.webp";